import { useState } from 'react'
import { Box, Card, CardBody, CardHeader, Flex, Heading, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'
import { UiBreadcrumb } from 'components/common'
import { UserForm, UserFormType } from './UserForm'
import { PasswordForm } from './PasswordForm'
import { updateUser } from 'api/userApi'
import { useAppContext } from 'hooks/useAppContext'

const BreadcrumbNav = [
  {
    label: 'Profile',
    isCurrentPage: true
  }
]

export const Profile = () => {
  const { currentUser, setCurrentUser, createToast } = useAppContext()
  const [formError, setFormError] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSave = async (form) => {
    setIsSubmitting(true)

    try {
      const formData = new FormData()
      formData.append('firstname', form.firstname)
      formData.append('lastname', form.lastname)
      formData.append('email', form.email)
      formData.append('phone', form.phone)
      formData.append('role', form.role)
      if (typeof form.image === 'object') {
        formData.append('image', form.image)
      }
      if (typeof form.image === 'string' && form.image !== currentUser.image) {
        formData.append('setDefaultImage', true)
      }
      const row = await updateUser(currentUser.id, formData)
      setCurrentUser(row)
      createToast('success', 'Profile updated')
      setIsSubmitting(false)
    } catch (err) {
      if (err.response.status === 400) {
        setFormError(err.response.data)
      } else {
        createToast('error', 'Error', err.response.data)
      }
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">Profile</Heading>
        </Flex>
        <Tabs variant="line" colorScheme="gray">
          <Card borderRadius={0}>
            <CardHeader bg="gray.500" p={4}>
              <TabList>
                <Tab>
                  <Heading color="white" size="sm">User Information</Heading>
                </Tab>
                <Tab>
                  <Heading color="white" size="sm">Change Password</Heading>
                </Tab>
              </TabList>
            </CardHeader>
            <CardBody p={8}>
              <TabPanels>
                <TabPanel>
                  <UserForm
                    type={UserFormType.Profile}
                    onSubmit={handleSave}
                    isSubmitting={isSubmitting}
                    initialForm={currentUser}
                    initialFormError={formError}
                  />
                </TabPanel>
                <TabPanel>
                  <PasswordForm />
                </TabPanel>
              </TabPanels>
            </CardBody>
          </Card>
        </Tabs>
      </Box>
    </>
  )
}
